module.exports = __webpack_public_path__ + "img/company_profile.74f6f9bf.png";